import { Pill } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";
import { formatDayOfMonthWithDayName } from "@src/appV2/redesign/utils/formatDayOfMonthWithDayName";

export function DatePill({ startDate }: { startDate: Date }) {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <Pill
        variant="outlined"
        sx={{ backgroundColor: (theme) => theme.palette.background.paper }}
        label={formatDayOfMonthWithDayName(startDate)}
      />
    </Box>
  );
}
